import React from "react";
import notify from "devextreme/ui/notify";
import Form, {
    SimpleItem,
    GroupItem,
    Label,
    EmptyItem,
} from "devextreme-react/form";
import "devextreme-react/text-area";
import UserInfo from "../../UserInfo";
import {
    inserirOuAtualizar,
    criarCpbsDs,
    criarAlvaraFuncionamentoESanitarioDs,
    criarTaxasDs,
} from "../../DataSources";
import sysCodigoDescricao from "../../components/sysCodigoDescricao";
import { Popup, ToolbarItem } from "devextreme-react/popup";
import { Button, ScrollView } from "devextreme-react";
import { TextBox, Button as TextBoxButton } from "devextreme-react/text-box";
import ShowError from "../../AppServices";
import CpbsBox from "../cpbs/CpbsBox";
import uiInfo from "../../ui-info";
//import { DataSource } from "devextreme/data/data_source/data_source";
import { abrirDetalhe } from "../../lancamentosUtils";
import DataSource from "devextreme/data/data_source";
import PaginaToolbar from "../../components/PaginaToolbar";
import {
    DataGrid,
    Column,
    Paging,
    Pager,
    Lookup,
    FormItem,
    ColumnChooser,
} from "devextreme-react/data-grid";
import api from "../../api-axios";
import { LoadIndicator } from "devextreme-react/load-indicator";

var dataCorrente = new Date();

const template = {
    id: undefined,
    exercicio: dataCorrente.getFullYear(),
    tipoAlvara: "TLLF",
    inscricoes: "",
    vencimento: dataCorrente,
    validade: new Date(dataCorrente.getFullYear(), 11, 31),
    dataCotaUnica: undefined,
    descontoCotaUnica: undefined,

    _uiExibirPreview: false,
    _uiLegendaDetalhe1: "Detalhe 1",
    _uiLegendaDetalhe2: "Detalhe 2",
    _uiLegendaDetalhe3: "Detalhe 3",
    _uiLegendaDetalhe4: "Detalhe 4",
    _uiLegendaDetalhe5: "Detalhe 5",

    _uiEstagio: 1,
    _uiAndamento: [],
    _uiItens: [
        {
            id: 1,
            status: "PENDENTE",
            nome: "RICARDO NORONHA DE MENEZES",
            cpfCnpj: "006.490.683-35",
            enderecoCompleto: "RUA ANTONIO LOTERO, 437 - CENTRO - NOVO ORIENTE - CE",
            baseCalculo: 20,
            lancamento: { valorImposto: 150.00 },
            valorPrevisto: 150.33,
            exercicioAnterior: 2022,
            valorAnterior: 130.44,
            percentualAumento: 15.24,
            detalhe1: "DETALHE 1 RICARDO",
            detalhe2: "DETALHE 2 RICARDO",
            detalhe3: "DETALHE 3 RICARDO",
            detalhe4: "DETALHE 4 RICARDO",
            detalhe5: "DETALHE 5 RICARDO",
            msgErro: "",
            stackTrace: "",

        },
        {
            id: 2,
            status: "PENDENTE",
            nome: "DAYANNA KARINNA MOREIRA LIMA",
            cpfCnpj: "026.104.563-60",
            enderecoCompleto: "RUA COELHO MASCARENHAS, 154 - CENTRO - NOVO ORIENTE/CE",
            baseCalculo: 44.30,
            valorPrevisto: 250.60,
            exercicioAnterior: 2021,
            valorAnterior: 200,
            percentualAumento: 25.30,
            detalhe1: "DETALHE 1 DAYANNA",
            detalhe2: "DETALHE 2 DAYANNA",
            detalhe3: "DETALHE 3 DAYANNA",
            detalhe4: "DETALHE 4 DAYANNA",
            detalhe5: "DETALHE 5 DAYANNA",
        }
    ]
};

export default class AlvaraEmLote extends React.Component {
    constructor(props) {





        super(props);
        this.cpbsDs = criarCpbsDs();
        this.alvarasFuncionamentoDs = criarAlvaraFuncionamentoESanitarioDs();
        this.saidaProgramada = false;
        template.prefeituraId = UserInfo.getPrefeitura();
        this.state = { ...template };

        this.cancel = this.cancel.bind(this);

        this.simular = this.simular.bind(this);
        this.lancarPopup = this.lancarPopup.bind(this);
        this.acompanharAndamento = this.acompanharAndamento.bind(this);
    }




    componentDidMount() {


    }

    componentWillUnmount() {
        if (this.intervaloAcompanhamento != undefined) {
            clearInterval(this.intervaloAcompanhamento);
        }
    }

    acompanharAndamento() {

        if (this.intervaloAcompanhamento != undefined) {
            clearInterval(this.intervaloAcompanhamento);
        }

        const prefeituraId = UserInfo.getPrefeitura();

        this.intervaloAcompanhamento = setInterval(() => {
            api.get(`/alvara_lote/acompanhamento/${prefeituraId}/${this.state.id}`)
                .then(resp => {

                    const data = resp.data;
                    
                    if (data.finalizado) {
                        clearInterval(this.intervaloAcompanhamento);
                    }

                    const estagio = data.finalizado ? 3 : 2;
                    const itens = data.finalizado ? data.itens : [];
                    const andamento = data.finalizado ? [] : data.andamento;


                    this.setState({ _uiEstagio: estagio, _uiAndamento: andamento, _uiItens: itens });

                })
                .catch(error => {
                    // if (error.response.status){
                    //     if (this.intervaloAcompanhamento!=undefined){
                    //         clearInterval(this.intervaloAcompanhamento);
                    //     }
                    // }
                    console.log("Erro ao buscar status processamento", error);
                    //notify("Erro ao buscar andamento do processamento", "error", 2000);
                });
        }, 5000);
    }


    renderEstagio1() {

        if (this.state._uiEstagio != 1 && this.state._uiEstagio != 3) {
            return null;
        }


        return (
            <div className={"content-block dx-card responsive-paddings"}>
                <form>
                    <Form formData={this.state} colCount={2}>
                        <GroupItem
                            caption={"LANÇAMENTO DE ALVARÁ EM LOTE"}
                            colSpan={2}
                            colCount={4}
                        >
                            <SimpleItem
                                colSpan={1}
                                dataField={"exercicio"}
                                editorType={"dxTextBox"}
                                editorOptions={{ onValueChanged: this.onExercicioAlterado, readOnly: this.state._uiEstagio != 1 }}
                            >
                                <Label text="Exercício" />
                            </SimpleItem>

                            <EmptyItem colSpan={3} />

                            <SimpleItem
                                dataField={"inscricoes"}
                                colSpan={4}
                                editorType="dxTextArea"
                                editorOptions={{ height: 90, readOnly: this.state._uiEstagio != 1 }}
                                helpText={"Ex.: 1, 2, 150-231, 321 (para todos deixe em branco)"}
                            >
                                <Label text="Inscrições" />
                            </SimpleItem>
                            <SimpleItem
                                colSpan={1}
                                dataType={"date"}
                                dataField={"vencimento"}
                                editorType={"dxDateBox"}
                                editorOptions={{ width: "100%", useMaskBehavior: true, readOnly: this.state._uiEstagio != 1 }}
                            >
                                <Label text="Vencimento" />
                            </SimpleItem>

                            <SimpleItem
                                colSpan={1}
                                dataField={"validade"}
                                editorType={"dxDateBox"}
                                editorOptions={{ width: "100%", useMaskBehavior: true, readOnly: this.state._uiEstagio != 1 }}
                            >
                                <Label text="Validade" />
                            </SimpleItem>


                            <SimpleItem
                                colSpan={1}
                                dataField={"dataCotaUnica"}
                                editorType={"dxDateBox"}
                                editorOptions={{
                                    showClearButton: true,
                                    useMaskBehavior: true,
                                    width: "100%",
                                    readOnly: this.state._uiEstagio != 1
                                }}
                            >
                                <Label text="Data Cota Única" />
                            </SimpleItem>

                            <SimpleItem
                                colSpan={1}
                                dataField={"descontoCotaUnica"}
                                editorType={"dxNumberBox"}
                                editorOptions={{ format: uiInfo.formatoNumerico.n2, readOnly: this.state._uiEstagio != 1 }}
                                cssClass={"txtNumerico"}
                            >
                                <Label text="% Desc. Conta Única" />
                            </SimpleItem>

                        </GroupItem>
                    </Form>
                    <div style={{ marginTop: "10px" }}>

                        <div style={{ display: "inline-block" }}>
                            <Button
                                width={120}
                                text="Lançar"
                                type="success"
                                onClick={this.simular}
                            />
                        </div>

                        <div style={{ display: "inline-block", marginLeft: "10px" }}>
                            <Button
                                width={120}
                                text="Simular"
                                type="default"
                                onClick={this.simular}
                            />
                        </div>

                    </div>
                </form>
            </div>
        );

    }

    renderEstagio2() {
        if (this.state._uiEstagio != 2) {
            return null;
        }

        return (
            <div className={"content-block dx-card responsive-paddings"}>
                <div style={{ maxWidth: 500, margin: "auto" }}>

                    <div
                        style={{
                            display: "flex",
                            marginTop: "25px",
                            justifyContent: "center",
                            alignContent: "center",
                            justifyItems: "center",
                            alignItems: "center",
                        }}
                    >
                        <LoadIndicator width={60} height={60} />
                    </div>

                    <h3 style={{ textAlign: "center" }}>STATUS DO PROCESSAMENTO</h3>

                    <DataGrid
                        ref={(grid) => (this._gridInstance = grid)}
                        dataSource={this.state._uiAndamento}
                        showBorders={true}
                        rowAlternationEnabled={true}
                        columnAutoWidth={true}
                        keyExpr={"status"}
                    >
                        <Column dataField={"status"} caption={"Status"} width={300} alignment={"center"} />

                        <Column
                            dataField={"quantidade"}
                            caption={"Quantidade"}
                            dataType={"number"}
                            format={uiInfo.formatoNumerico.inteiroComPonto}
                            width={200}
                            alignment={"center"}
                        />
                    </DataGrid>

                    <div style={{ display: "block", width: "250px", margin: "25px auto", alignItems: "center" }}>

                        <Button
                            width={250}
                            text="Sair do acompanhamento"
                            onClick={this.simular}
                        />
                    </div>
                </div>



            </div>
        );
    }


    renderEstagio3() {

        if (this.state._uiEstagio != 3) {
            return null;
        }

        return (
            <div className={"content-block dx-card responsive-paddings"}>
                <h2 style={{ textAlign: "center" }}>ITENS DO CÁLCULO</h2>
                <PaginaToolbar ocultarNovo={true} titulo={"Itens"}>
                    <DataGrid
                        ref={(grid) => (this._gridInstance = grid)}
                        dataSource={this.state._uiItens}
                        showBorders={true}
                        rowAlternationEnabled={true}
                        remoteOperations={true}
                        columnAutoWidth={true}
                        focusedRowEnabled={true}
                        allowColumnReordering={true}
                        keyExpr={"id"}
                        filterPanel={true}
                    >
                        <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />
                        <Pager
                            showPageSizeSelector={true}
                            allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
                            showInfo={true}
                        />
                        <Column dataField={"id"} caption={"#"} />

                        <Column dataField={"status"} caption={"Status"} />

                        <Column dataField={"nome"} caption={"Nome"} />

                        <Column dataField={"cpfCnpj"} caption={"CPF/CNPJ"} />

                        <Column
                            dataField={"baseCalculo"}
                            caption={"Base Cálculo"}
                            dataType={"number"}
                            format={uiInfo.formatoNumerico.n2}
                        />
                        <Column
                            dataField={"lancamento.valorImposto"}
                            caption={"Valor Gerado"}
                            dataType={"number"}
                            format={uiInfo.formatoNumerico.n2}
                        />



                        <Column
                            dataField={"valorPrevisto"}
                            caption={"Valor Previsto"}
                            dataType={"number"}
                            format={uiInfo.formatoNumerico.n2}
                        />

                        <Column
                            dataField={"exercicioAnterior"}
                            caption={"Exercício Anterior"}
                            dataType={"number"}
                            format={uiInfo.formatoNumerico.inteiroSemPonto}
                        />

                        <Column
                            dataField={"valorAnterior"}
                            caption={"Valor Anterior"}
                            dataType={"number"}
                            format={uiInfo.formatoNumerico.n2}
                        />

                        <Column
                            dataField={"percentualAumento"}
                            caption={"% Aumento"}
                            dataType={"number"}
                            format={uiInfo.formatoNumerico.n2}
                        />

                        <Column dataField={"endereco"} caption={"Endereço"} visible={false} />
                        <Column dataField={"detalhe1"} caption={this.state.legendaDetalhe1} />
                        <Column dataField={"detalhe2"} caption={this.state.legendaDetalhe2} />
                        <Column dataField={"detalhe3"} caption={this.state.legendaDetalhe3} />
                        <Column dataField={"detalhe4"} caption={this.state.legendaDetalhe4} />
                        <Column dataField={"detalhe5"} caption={this.state.legendaDetalhe5} />
                        <Column dataField={"msgErro"} caption={"Erro"} visible={false} />
                        <Column dataField={"stackTrace"} caption={"Stack Trace"} visible={false} />
                    </DataGrid>
                </PaginaToolbar>

            </div>
        );


    }


    render() {

        const estagio1 = this.renderEstagio1();
        const estagio2 = this.renderEstagio2();
        const estagio3 = this.renderEstagio3();



        return (
            < React.Fragment >
                {estagio1}
                {estagio2}
                {estagio3}
                <Popup
                    visible={this.state._uiExibirPreview}
                    onHiding={(e) => this.setState({ exibirPopupPreview: false })}
                    dragEnabled={false}
                    closeOnOutsideClick={false}
                    showCloseButton={false}
                    showTitle={true}
                    width={600}
                    height={220}
                    title="Confirmação..."
                >
                    <ScrollView showScrollbar="always">
                        <p>Tem certeza que deseja lançar sem realizar previsão e conferir os valores de lançamento?</p>
                    </ScrollView>
                    <ToolbarItem
                        toolbar={"bottom"}
                        widget="dxButton"
                        location="center"
                        options={{
                            text: "Lançar",
                            type: "success",
                            width: 150,
                            onClick: this.lancarPopup,
                        }}
                    ></ToolbarItem>
                    <ToolbarItem
                        toolbar={"bottom"}
                        widget="dxButton"
                        location="center"
                        options={{
                            text: "Cancelar",
                            type: "default",
                            width: 150,
                            onClick: () => this.setState({ exibirPopupPreview: false }),
                        }}
                    ></ToolbarItem>
                </Popup>
            </React.Fragment >
        );
    }

    simular() {
        this.lancar(true);

    }

    lancarPopup() {
        this.lancar(false);
    }

    lancar(preview) {
        let entidade = { ...this.state };
        entidade.tipoSolicitacao = preview ? "P" : "L";
        entidade.prefeituraId = UserInfo.getPrefeitura();
        console.log("dados alvará em lote", entidade);
        api.post("/alvara_lote/lancamento", entidade)
            .then(resp => {
                this.setState({ id: resp.data, _uiEstagio: 2 });
                this.acompanharAndamento();
            })
            .catch(error => {
                console.log(error);
                notify(error, "error");
            })

    }

    cancel() {
        notify("Operação cancelada", "warning");
        this.props.history.goBack();
    }
}
